import { connect } from "react-redux";

import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { queryPicklistAction } from "../../../Engine/ActionCreators/PicklistActionCreators";
import { checkIsSuitableToClick, externalOnClickHandler } from "../../../Engine/ActionCreators/ExternalOnClickAction";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { WithHighlightedInjectableProps, withHighlighting } from "../../withHighlighting";

import { TaxRebate } from "./TaxRebate";

export interface TaxRebateContainerProps extends WithHighlightedInjectableProps {
    bindingPath: AbsoluteResolvedModelPath;
    gId: string;
    disabled?: EvaluableProp<boolean>;
    viewModelSelect: ViewModelSelect;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, props: TaxRebateContainerProps) => {
    const { bindingPath, viewModelSelect, disabled, processEvaluableProp } = props;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        disabled: processEvaluableProp(state, disabled),
        isTooltipEnabled: controlModel.isTooltipEnabled,
        value: controlModel.value ?? "",
        error: controlModel.error,
        warning: controlModel.warning,
        highlighted: props.highlighted,
        isReadOnly: state.settings.isReadOnly,
        isLink: checkIsSuitableToClick(state.settings, bindingPath),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, props: TaxRebateContainerProps) => ({
    onChange: (value: undefined | string) => dispatch(setToModel(props.bindingPath, "value", value)),
    onFetchAllTaxRebates: async () => (await dispatch(queryPicklistAction({ gId: props.gId }))).items,
    onClick: () => externalOnClickHandler(dispatch, props.bindingPath),
});

export const TaxRebateContainer = withResolvePaths(
    withViewModelSelect(
        withEvaluators(
            withHighlighting(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(withFocusManagement(withTestPageObjectRegistration(withControlDebugInfo(TaxRebate))))
            )
        )
    )
);
